<div class="flex flex-col gap-6">
  <span class="text-xl font-bold">Gestión del riesgo</span>

  <div class="flex flex-col gap-3">
    <div class="flex gap-3 items-start">
      <input
        *ngIf="reviewMode && !readonlyReview"
        type="checkbox"
        class="mt-1"
        [checked]="reviewFields.isFieldMarked('projectClassification')"
        (change)="reviewFields.toggleField('projectClassification')" />
      <div class="flex flex-col gap-2">
        <div class="flex items-start gap-2">
          <span class="text-sm text-neutral-dark">Clasificación del sistema</span>
          <app-tooltip
            *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('projectClassification')"
            class="-mt-2"
            [description]="previousReviewText('projectClassification')"
            tipeIcon="info"></app-tooltip>
        </div>
        <span
          class="text-md font-semibold"
          [ngClass]="project?.projectClassification | riskLevelClass">
          {{ riskLevelLabel(project?.projectClassification) || '-' }}
        </span>
      </div>
    </div>
  </div>
</div>
